import { phappsRequest } from './apiService';
import { API_PATHS } from '@/config/apiConstants';

export const listConferences  = ()      => phappsRequest(API_PATHS.CONFERENCES, 'GET');
export const getConference    = (id)    => phappsRequest(API_PATHS.CONFERENCE_BY_ID(id), 'GET');
export const createConference = (body)  => phappsRequest(API_PATHS.CONFERENCES, 'POST', body);
export const updateConference = (id, body) => phappsRequest(API_PATHS.CONFERENCE_BY_ID(id), 'PUT', body);
export const deleteConference = (id)    => phappsRequest(API_PATHS.CONFERENCE_BY_ID(id), 'DELETE');
export const updateChecklistItem = (confId, itemId, body) =>
  phappsRequest(API_PATHS.CONFERENCE_CHECKLIST_ITEM(confId, itemId), 'PATCH', body);
export const addChecklistItem    = (confId, label) =>
  phappsRequest(API_PATHS.CONFERENCE_ITEMS(confId), 'POST', { label });
export const deleteChecklistItem = (confId, itemId) =>
  phappsRequest(API_PATHS.CONFERENCE_CHECKLIST_ITEM(confId, itemId), 'DELETE');
